import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@/utils/errorMessage';
import { AvailableDateService } from '../available-date.service';

export const useCreateAvailableDate = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const createAvailableMutation = useMutation({
		mutationFn: (body: AvailableDates.Create) =>
			AvailableDateService.create(body),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['available-dates'],
				exact: false,
			});
			toast.success('Horário criado com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Erro na criação do horário'));
		},
	});

	return createAvailableMutation;
};

export const useUpdateAvailableDate = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const updateAvailableMutation = useMutation({
		mutationFn: (data: AvailableDates.Update) =>
			AvailableDateService.patch(data),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['available-dates'],
				exact: false,
			});
			toast.success('Horário atualizado com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(
				getErrorMessage(error, 'Erro na atualização do horário'),
			);
		},
	});

	return updateAvailableMutation;
};

export const useDeleteAvailableDate = (onSuccess?: (id: string) => void) => {
	const deleteAvailableMutation = useMutation({
		mutationFn: (id: string) => AvailableDateService.destroy(id),
		onSuccess: (_data, variables) => {
			const deletedId = variables as string;
			toast.success('Horário deletado com sucesso!');
			if (onSuccess) onSuccess(deletedId);
		},
		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Erro no delete do horário'));
		},
	});

	return deleteAvailableMutation;
};
